import { Icon } from '@openeducation/oe-rn-components';
import React from 'react';
import { Dimensions, View } from 'react-native';

import { useColors, useFont } from '../../../hooks/lesson-player.context';
import { ThemedText } from '../../themed-text';
import { extraSmallPaddingBox } from '../../view-style';

interface CollapsebleTexButtontProps {
  style?;
  typeText?;
  nameIcon?;
  text?;
  buttonColor?;
}
export function CollapsebleTextButton({
  style,
  typeText = 'primary',
  nameIcon = 'angle-up',
  text = 'Hide text',
  buttonColor,
}: CollapsebleTexButtontProps) {
  const color = useColors();
  const fonts = useFont();
  let iconSize = 8;
  if (Dimensions.get('screen').width > 767) {
    iconSize = 16;
  }

  buttonColor = buttonColor || color.primary;

  return (
    <View style={{ ...extraSmallPaddingBox }}>
      <ThemedText
        type={typeText}
        fontSize="extraSmall"
        style={{
          ...fonts.primary.regular,
        }}
      >
        {text}{' '}
        <Icon
          style={style}
          color={buttonColor}
          size={iconSize}
          name={nameIcon}
          type="solid"
        />
      </ThemedText>
    </View>
  );
}
